// extracted by mini-css-extract-plugin
module.exports = {"titleContainer":"CreateEditEquipmentSchedule_titleContainer__2njyy","assignButton":"CreateEditEquipmentSchedule_assignButton__3Sbkx"};